import { render, staticRenderFns } from "./WebmastersProfileEditCard.vue?vue&type=template&id=88b1d5f6&scoped=true"
import script from "./WebmastersProfileEditCard.vue?vue&type=script&lang=js"
export * from "./WebmastersProfileEditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b1d5f6",
  null
  
)

export default component.exports